// =========================================================
// BALBONI STORE - Essential Loyalty
// =========================================================


// ---- BOTÓN "COMPRA PARA GANAR PUNTOS" ----
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function(mutations, obs) {
    const target = document.querySelector('.essential-wte-actions');
    if (target) {
      const btn = document.createElement('a');
      btn.href = '/collections/all';
      btn.textContent = 'Compra para ganar puntos';
      btn.className = 'btn button';
      btn.style.cssText = 'display:block; text-align:center; margin: 24px auto 0; width:fit-content;';
      target.insertAdjacentElement('afterend', btn);
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


// ---- BADGE "AGOTADO" EN RECOMPENSAS SIN STOCK ----
(function () {
  if (!window.location.pathname.includes('/pages/loyalty-program')) return;

  const AGOTADO_CLASS = 'hp-agotado-badge';

  function checkOutOfStock() {
    const cards = document.querySelectorAll('.essential-card.essential-card-reward');
    if (cards.length === 0) return;

    const alreadyLoaded = Array.from(cards).some(card => {
      const imgs = card.querySelectorAll('.essential-card-icon img');
      if (imgs.length < 2) return false;
      const src = imgs[1].getAttribute('src');
      return src && src.length > 0;
    });

    if (!alreadyLoaded) {
      setTimeout(checkOutOfStock, 500);
      return;
    }

    cards.forEach(card => {
      const imgs = card.querySelectorAll('.essential-card-icon img');
      if (imgs.length < 2) return;

      const productImg = imgs[1];
      const src = productImg.getAttribute('src');
      const existingBadge = card.querySelector('.' + AGOTADO_CLASS);

      if (src === '' || src === null) {
        if (!existingBadge) {
          const badge = document.createElement('div');
          badge.className = AGOTADO_CLASS;
          badge.textContent = 'AGOTADO';
          card.querySelector('.essential-card-icon').appendChild(badge);
        }
      } else {
        if (existingBadge) existingBadge.remove();
      }
    });
  }

  const observer = new MutationObserver(() => checkOutOfStock());
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(checkOutOfStock, 1000);
})();